import React from 'react'
import { Link, useHistory } from 'react-router-dom'

import AppBar from '@material-ui/core/AppBar'
import CssBaseline from '@material-ui/core/CssBaseline'
import IconButton from '@material-ui/core/IconButton'
// import { ReactComponent as MenuIcon } from 'src/assets/icon/menu-icon.svg'

import { ReactComponent as CloseIcon } from 'src/assets/icon/close-icon.svg'
import { ReactComponent as SearchIcon } from 'src/assets/icon/search-icon.svg'
import Toolbar from '@material-ui/core/Toolbar'
// import Typography from '@material-ui/core/Typography'
import logoSrc from 'src/assets/img/logo.png'
// import chatIcon from 'src/assets/icon/chat-icon.svg'
import MenuSrc from 'src/assets/img/Menu.png'
// import OrderHeaderIcon from 'src/assets/icon/order-svgrepo-com.svg'
// import OrderDrawerIcon from 'src/assets/icon/message-box-svgrepo-com.svg'
import LanguageButton from '../LanguageButton'
import { useLocation } from 'react-router'
import AccountDropDown from '../AccountDropDown'
import { useTranslation } from 'react-i18next'
import useStyles from './useStyles'
// import SingleAutoComplete from '../SingleAutoComplete'

import { CartContext } from 'src/shared/components/CartProvider'
import useGetOrderLens from 'src/pages/Cart/services/getOrderLens/hooks'
import useGetOrderOther from 'src/pages/Cart/services/getOrderOther/hooks'
import useGetOrdersStatusCount from 'src/pages/Orders/services/getOrdersStatusCount/hooks'
import useGetAccountPermission from 'src/shared/services/getAccountPermission/hooks'

// import Tooltip from 'src/simulationAdaptation2/components/EyesTextBox/components/TooltipDown'
interface Props {
  isMenuOpen: boolean
  doSubmitAutoComplete: (value: string) => void
  setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const Header: React.FC<Props> = (props) => {
  const { data: orderLensData = [] } = useGetOrderLens()
  const { data: orderOtherResponse } = useGetOrderOther()
  const { data: orderStatusData } = useGetOrdersStatusCount('2')
  const { data: permission } = useGetAccountPermission()

  const userId = permission?.data.result_data.user_id || NaN
  const dropsData = orderOtherResponse?.drops
  const otherData = orderOtherResponse?.others
  const history = useHistory()
  const isDropsData = dropsData ? 1 : 0

  const classes = useStyles()
  const param = useLocation()
  const { t } = useTranslation()
  // const isHome = param.pathname.search('home') >= 0
  const { isMenuOpen, setIsMenuOpen } = props

  const cartRef = React.useRef<HTMLImageElement>(null)
  const chart = React.useContext(CartContext)

  React.useEffect(() => {
    chart?.setAnchorEl(cartRef.current as HTMLElement)
  }, [])

  const handleDrawerToggle = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const searchReturnPath = window.localStorage.getItem('searchReturnPath')

  const handleSearch = () => {
    if (searchReturnPath) {
      history.push(searchReturnPath)
      window.localStorage.removeItem('searchReturnPath')
    } else {
      history.push('/pages/products/search-results')
      window.localStorage.setItem('searchReturnPath', param.pathname)
    }
  }

  // const keyWordFromStorage = window.localStorage.getItem(`searchProductsKeywords`)

  // const currentKeyWord = React.useMemo(() => {
  //   if (!keyWordFromStorage) return []
  //   return JSON.parse(keyWordFromStorage) as string[]
  // }, [keyWordFromStorage])

  return (
    <div>
      <CssBaseline />
      <AppBar position='fixed' className={classes.appBar}>
        <Toolbar>
          <IconButton disableRipple aria-label='open drawer' edge='start' onClick={handleDrawerToggle} className={classes.menuButton}>
            {isMenuOpen ? <CloseIcon /> : <img src={MenuSrc} alt='' />}
          </IconButton>
          <img className={classes.headerTopLg} src={logoSrc} alt='' />
          <IconButton onClick={handleSearch} style={{ color: '#ffff' }}>
            {searchReturnPath ? <CloseIcon /> : <SearchIcon />}
          </IconButton>
        </Toolbar>
      </AppBar>
      <div className={classes.headerLg}>
        <div className={classes.headerLgLeft}>
          {/* <SingleAutoComplete
            pageKeywordName={`searchProductsKeywords`}
            placeholder={t('global1')}
            onSubmit={props.doSubmitAutoComplete}
            options={currentKeyWord}
          /> */}
        </div>

        <div className={classes.headerLgRight}>
          <div className={classes.headerStatusList}>
            {(userId !== 123 && Array.isArray(dropsData)) ||
              (Array.isArray(otherData) && otherData.length > 0) ||
              (orderLensData.length + isDropsData > 0 && (
                <span className={classes.headerStatusItem}>
                  <Link to='/pages/cart'>
                    {t('header.icon.shopcart')}
                    <span className={classes.redDot}>{orderLensData.length + isDropsData}</span>
                  </Link>
                </span>
              ))}

            {userId != 123 && !!orderStatusData?.data.result_data[0].count && (
              <span className={classes.headerStatusItem}>
                <Link to='/pages/orders/processing'>
                  {t('header.icon.order')}
                  <span className={classes.redDot}>{orderStatusData?.data.result_data[0].count}</span>
                </Link>
              </span>
            )}
          </div>

          <AccountDropDown />
          <div>
            <LanguageButton className={classes.languageButton} />
          </div>
        </div>
      </div>
      {/* {isHome && (
        <AppBar position='fixed' className={classes.appBarLogo}>
          <Toolbar className={classes.toolBarlogo}>
            <div className={classes.appBarLogoBox} onClick={() => history.push(`/simulation-adaptation/patient-list`)}>
              <img src={logoSrc} alt='' />
              <Typography>{t('home.simulation')}</Typography>
            </div>
          </Toolbar>
        </AppBar>
      )} */}
    </div>
  )
}

export default Header
